"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiTab = void 0;
const callable_1 = require("client/components/ui/callable");
const react_1 = require("react");
const React = require("react");
require("./tab.less");
class UiTab extends react_1.Component {
    constructor() {
        super(...arguments);
        this.handleClick = () => {
            callable_1.callable(this.props.onClick)(event);
        };
    }
    render() {
        const { active, label = "" } = this.props;
        const activeClass = active ? "ui-tab--active" : "";
        return (React.createElement("div", { className: `ui-tab ${activeClass}`, onClick: this.handleClick },
            React.createElement("div", { className: "ui-tab__label" }, label)));
    }
}
exports.UiTab = UiTab;



//////////////////
// WEBPACK FOOTER
// ./src/client/components/ui/tab-view/tab.tsx
// module id = 2193
// module chunks = 0 1